import { type IFrontendUrls } from '@gbs-monorepo-packages/common';

import { ADMIN_URL, CLIENT_URL, EDGE_URL } from './Env';

export const FRONTEND_URLS: IFrontendUrls = {
  adminRoute: ADMIN_URL,
  edgeRoute: EDGE_URL,
  clientRoute: CLIENT_URL,
};
